import React from 'react'
import TwoStepPaymentFormStepButtonSubTextUi from './ui/two-step-payment-form-step-button-subtext-ui'
import TwoStepPaymentFormStepButtonTextUi from './ui/two-step-payment-form-step-button-text-ui'
import TwoStepPaymentFormStepButtonUi from './ui/two-step-payment-form-step-button-ui'

export interface TwoStepPaymentFormStepButtonProps {
  // biome-ignore lint/suspicious/noExplicitAny: any arguments are ok, the any typing is intentional
  onClick?: (...args: any) => Promise<void> | void
  backgroundColor?: string
  mobileBackgroundColor?: string
  color: string
  mobileColor?: string
  subText: string
  text: string
  disabled?: boolean
}

export const TwoStepPaymentFormStepButton = ({
  text,
  subText,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
  onClick,
  disabled = false,
}: TwoStepPaymentFormStepButtonProps) => {
  return (
    <TwoStepPaymentFormStepButtonUi
      color={color}
      mobileColor={mobileColor}
      backgroundColor={backgroundColor}
      mobileBackgroundColor={mobileBackgroundColor}
      onClick={onClick}
      disabled={disabled}
    >
      <TwoStepPaymentFormStepButtonTextUi>
        {text}
      </TwoStepPaymentFormStepButtonTextUi>
      {subText && (
        <TwoStepPaymentFormStepButtonSubTextUi>
          {subText}
        </TwoStepPaymentFormStepButtonSubTextUi>
      )}
    </TwoStepPaymentFormStepButtonUi>
  )
}
